import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasProperties from './aidas-properties';
import AidasPropertiesDetail from './aidas-properties-detail';
import AidasPropertiesUpdate from './aidas-properties-update';
import AidasPropertiesDeleteDialog from './aidas-properties-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasPropertiesUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasPropertiesUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasPropertiesDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasProperties} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasPropertiesDeleteDialog} />
  </>
);

export default Routes;
